// react
import React, { useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectShoppingCart, resetShoppingCart } from '_redux/slices/marketplace/user-marketplace';

// styles
import { Colors, Spacing } from '_styles';
import { FaShoppingCart } from 'react-icons/fa';

// bootstrap
import Image from 'react-bootstrap/Image';
import image from "_assets/images/PRM-Logo-PNG/logo.png";

// custom components
import { ShoppingCart } from '_components/organisms';
import PRMLogo from '../../../../../components/atoms/images/prm-logo';
import { NetworkStatusBanner } from '_components/molecules';
import { CustomSpinner } from '_atoms'

const RetailerTitle = ({ retailer, handleLogoClick, hideCart }) => {

    // redux
    const cart = useSelector(selectShoppingCart) || {};

    // local states
    const [showModal, setShowModal] = useState(false);
    const totalQuantity = Object.values(cart).reduce((sum, item) => sum + (item.quantity || 0), 0);
    

    return (
        <div style={styles.bannerWrapper}>

            {/* warning if no internet */}
            <NetworkStatusBanner />

            {/* make background retailer image */}
            <div style={{ ...styles.bannerImage, backgroundImage: `url(${retailer?.imageUrl})` }}>

                {/* overlay text with shopping cart */}
                <div style={styles.overlay}>

                    <div style={styles.titleContainer}>

                        {/* prm logo */}
                        <div onClick={handleLogoClick}>
                            <Image
                                src={image}
                                height={50}
                                width={50}
                                style={styles.logo}
                            />
                        </div>

                        {/* retailer title */}
                        <div style={styles.titleTextContainer}>
                            <p style={styles.title}>{retailer?.retailerName}</p>
                        </div>

                    </div>

                    {!hideCart && (
                        <div style={styles.cartWrapper}>
                            <div style={styles.wrapper}>
                                <FaShoppingCart style={styles.icon} onClick={() => setShowModal(true)} />
                                {totalQuantity > 0 && <div style={styles.bubble}>{totalQuantity}</div>}
                            </div>
                        </div>
                    )}

                    {showModal && (
                        <ShoppingCart showModal={showModal} setShowModal={setShowModal} />
                    )}
                </div>
            </div>

        </div>
    );
};

//#region styles
const styles = {
    bannerWrapper: {
        overflow: 'hidden',
        position: 'relative',
    },
    bannerImage: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: Spacing.SCALE_200,
        position: 'relative',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'relative',
        borderWidth: 1, borderStyle: 'solid',
        padding: Spacing.SCALE_12
    },
    title: {
        fontSize: 38,
        fontWeight: 'bold',
        color: '#fff',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    titleTextContainer: {

    },
    cartWrapper: {
        position: 'absolute',
        right: Spacing.SCALE_20,
        top: Spacing.SCALE_20,
    },
    logo: {
        borderRadius: 25
    },
    wrapper: {
        position: 'relative'
    },
    icon: {
        fontSize: 32,
        color: '#fff',
        cursor: 'pointer',
    },
    bubble: {
        position: 'absolute',
        top: -Spacing.SCALE_6,
        right: -Spacing.SCALE_6,
        backgroundColor: Colors.PRM_LIGHT_BLUE,
        color: '#fff',
        borderRadius: '50%',
        width: Spacing.SCALE_20,
        height: Spacing.SCALE_20,
        fontSize: 12,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
    },
};
//#endregion

export default RetailerTitle;
